export const isWindow = (): boolean => typeof window !== "undefined";

export const isServer = (): boolean => typeof window === "undefined";